import { getApiError } from '~/api/problem'
import { ActionErrorType } from '~/domains/actions/errors'

const DEFAULT_MESSAGE = "La tâche n'a pas pu être créée"

export const getTaskCreationErrorMessage = (error: unknown): string => {
  const problem = getApiError(error)
  switch (problem?.type) {
    case ActionErrorType.LimitExceeded: {
      const limit = problem.extensions.limit
      return typeof limit === 'number'
        ? `Vous ne pouvez pas créer plus de ${limit} tâche${limit > 1 ? 's' : ''} à la fois`
        : 'Vous ne pouvez pas créer autant de tâches à la fois'
    }
    default:
      return DEFAULT_MESSAGE
  }
}
